module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box",
    class: {
      '-day': _vm.turno === 'manha', '-night': _vm.turno === 'noite'
    }
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h4', {
    staticClass: "recuperacao-titulo"
  }, [_vm._v("Recuperação de senha")]), _vm._v(" "), _c('div', {
    staticClass: "login-form-item"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.matricula),
      expression: "matricula"
    }],
    ref: "matricula",
    attrs: {
      "type": "tel",
      "placeholder": "Matrícula"
    },
    domProps: {
      "value": (_vm.matricula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.matricula = $event.target.value
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.recuperarSenha($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-item"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.novaSenha),
      expression: "novaSenha"
    }],
    ref: "novaSenha",
    attrs: {
      "type": "password",
      "placeholder": "Nova Senha"
    },
    domProps: {
      "value": (_vm.novaSenha)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.novaSenha = $event.target.value
      }, function($event) {
        return _vm.$v.novaSenha.$touch()
      }],
      "blur": function($event) {
        return _vm.$v.novaSenha.$touch()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.recuperarSenha($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-item"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.novaSenhaConfirmacao),
      expression: "novaSenhaConfirmacao"
    }],
    ref: "novaSenhaConfirmacao",
    attrs: {
      "type": "password",
      "placeholder": "Confirmação de Senha"
    },
    domProps: {
      "value": (_vm.novaSenhaConfirmacao)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.novaSenhaConfirmacao = $event.target.value
      }, function($event) {
        return _vm.$v.novaSenhaConfirmacao.$touch()
      }],
      "blur": function($event) {
        return _vm.$v.novaSenhaConfirmacao.$touch()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.recuperarSenha($event)
      }
    }
  })]), _vm._v(" "), _c('v-alert', {
    staticClass: "erros-validacao",
    attrs: {
      "value": _vm.senhaNovaSenhaErros.length || _vm.senhaNovaSenhaConfirmacaoErros.length,
      "color": "error",
      "icon": "warning"
    }
  }, [_vm._l((_vm.senhaNovaSenhaErros), function(item) {
    return _c('div', [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _vm._l((_vm.senhaNovaSenhaConfirmacaoErros), function(item) {
    return _c('div', [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "login-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.botaoClicado || _vm.$v.$invalid || !_vm.hashValido || _vm.senhasDiferentes
    },
    on: {
      "click": _vm.recuperarSenha
    }
  }, [_vm._v("\n                    Alterar Senha\n                ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('h2', {
    staticClass: "login-header-title"
  }, [_vm._v("SOU")]), _vm._v(" "), _c('figure', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "https://urcamp.edu.br/site/img/logos/logo-branco.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78f6a2b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/login/components/RecuperarSenha.vue
// module id = 562
// module chunks = 2